/* keycodes abstractions */
game.config.keycodes = {
  KEY_ARROW_LEFT: 37,
  KEY_ARROW_UP: 38,
  KEY_ARROW_RIGHT: 39,
  KEY_ARROW_DOWN: 40,
  KEY_ESCAPE: 2,
  KEY_RETURN: 13
};
